import CreatorAccessRoute from './components/CreatorAccessRoute';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux';
import store from './store.js';

import './assets/styles/bootstrap.custom.css'
import './assets/styles/index.css';
import App from './App';
import NotFound from './screens/NotFoundScreen';
import HomeScreen from './screens/HomeScreen';
import SearchScreen from './screens/SearchScreen';
import ProductScreen from './screens/ProductScreen';
import CartScreen from './screens/CartScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import ForgotPasswordScreen from './screens/ForgotPasswordScreen';
import ResetPasswordScreen from './screens/ResetPasswordScreen';
import VerifyEmailScreen from './screens/VerifyEmailScreen';
import VerifyEmailNoticeScreen from './screens/VerifyEmailNoticeScreen';
import ShippingScreen from './screens/ShippingScreen';
import PaymentScreen from './screens/PaymentScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import InvoiceScreen from './screens/InvoiceScreen';
import ProfileScreen from './screens/ProfileScreen';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute'
import OrderListScreen from './screens/admin/OrderListScreen';
import ProductListScreen from './screens/admin/ProductListScreen';
import ProductEditScreen from './screens/admin/ProductEditScreen';
import UserListScreen from './screens/admin/UserListScreen';
import UserEditScreen from './screens/admin/UserEditScreen';
import AdminOperationsScreen from './screens/admin/AdminOperationsScreen.jsx';
import CreatorScreen from './screens/CreatorScreen';
import CreatorEditScreen from './screens/CreatorEditScreen';
import CreatorProductEditScreen from './screens/creator/CreatorProductEditScreen';
import BecomeCreatorScreen from './screens/BecomeCreatorScreen';
import PurchaseHistoryScreen from './screens/PurchaseHistoryScreen';
import PurchaseProductScreen from './screens/PurchaseProductScreen';
import WishlistScreen from './screens/WishlistScreen';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import PrivacyPolicyScreen from './screens/PrivacyPolicy.jsx';
import TermsAndConditionsScreen from './screens/TermsAndConditions.jsx';
import HelpScreen from './screens/HelpScreen.jsx';
import SecurityScreen from './screens/SecurityScreen.jsx';
import WhoWeAreScreen from './screens/WhoWeAreScreen.jsx';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path ="/" element={<ErrorBoundary><App /></ErrorBoundary>} >
      <Route index={true} path="/" element={<HomeScreen />} />
      <Route path="/page/:pageNumber" element={<SearchScreen />} />
      <Route path="/search/:keyword?/sort?/:sort?/min?/:min?/max?/:max?/page?/:pageNumber?" element={<SearchScreen />} />
      <Route path="/product/:id" element={<ProductScreen />} />
      <Route path="/cart" element={<CartScreen />} />
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/register" element={<RegisterScreen />} />
      <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
      <Route path="/reset-password" element={<ResetPasswordScreen />} />
      <Route path="/verify-email" element={<VerifyEmailScreen />} />
      <Route path="/verify-email/notice" element={<VerifyEmailNoticeScreen />} />
      <Route path="/user/creator/:tag/search?/:keyword?/sort?/:sort?/min?/:min?/max?/:max?/page?/:pageNumber?" element={<CreatorScreen />} />
      <Route path="*" element={<NotFound />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyScreen />} />
      <Route path="/terms" element={<TermsAndConditionsScreen />} />
      <Route path="/help" element={<HelpScreen />} />
      <Route path="/security" element={<SecurityScreen />} />
      <Route path="/who-we-are" element={<WhoWeAreScreen />} />


      
      <Route path ='' element={<PrivateRoute />}>
      <Route path="/shipping" element={<ShippingScreen />} />
      <Route path="/payment" element={<PaymentScreen />} />
      <Route path="/placeorder" element={<PlaceOrderScreen />} />
      <Route path="/order/:id" element={<OrderScreen />} />
      <Route path="/order/:id/invoice" element={<InvoiceScreen />} />
      <Route path="/profile" element={<ProfileScreen />} />
      <Route path="/purchases" element={<PurchaseHistoryScreen />} />
      <Route path="/wishlist" element={<WishlistScreen />} />
      <Route path="/purchases/purchased-product" element={<PurchaseProductScreen />} />
      <Route element={<CreatorAccessRoute />}>
      <Route path="/profile/creator/" element={<CreatorEditScreen />} />
      <Route path="/profile/creator/search?/:keyword?/sort?/:sort?/page?/:pageNumber?" element={<CreatorEditScreen />} />
      <Route path="/profile/creator/:id/edit" element={<CreatorProductEditScreen />} />
      </Route>
      <Route element={<CreatorAccessRoute upgrade />}>
      <Route path="/profile/become-a-creator/" element={<BecomeCreatorScreen />} />
      </Route>
      </Route>

      <Route path ='' element={<AdminRoute />}>
      <Route path="/admin/orderlist" element={<OrderListScreen />} />
      <Route path="/admin/productlist" element={<ProductListScreen />} />
      <Route path="/admin/productlist/:pageNumber" element={<ProductListScreen />} />
      <Route path="/admin/product/:id/edit" element={<ProductEditScreen />} />
      <Route path="/admin/userlist" element={<UserListScreen />} />
      <Route path="/admin/user/:id/edit" element={<UserEditScreen />} />
      <Route path="/admin/operations" element={<AdminOperationsScreen />} />


      
      </Route>
      </Route>
  )
)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
    </HelmetProvider>
  </React.StrictMode>
);


